import Header from "../components/shared/Header";
import Footer from "../components/shared/Footer";
import SEOHead from "../components/shared/SEOHead";
import Breadcrumbs from "../components/shared/Breadcrumbs";
import { Link } from "react-router-dom";
import { Star, MapPin, Quote, ArrowRight } from "lucide-react";

const ReviewsPage = () => {
  const reviews = [
    { name: "Sarah Thompson", location: "Cardiff", rating: 5, text: "Absolutely brilliant service! The team were punctual, careful with all our belongings, and made what could have been a stressful day completely stress-free. Would highly recommend to anyone moving in Cardiff.", date: "December 2025" },
    { name: "James Mitchell", location: "London", rating: 5, text: "Used Hitech Transit for our office relocation. They worked over the weekend to minimize disruption. Highly professional throughout. The project manager kept us informed every step of the way.", date: "November 2025" },
    { name: "Emma Williams", location: "Newport", rating: 5, text: "Moved my elderly mother's house contents including antique furniture. They treated everything with such care. The team were patient and respectful. Can't recommend enough!", date: "November 2025" },
    { name: "David Roberts", location: "Bristol", rating: 5, text: "Moving from Bristol to Cardiff seemed daunting but Hitech made it simple. Fair pricing, great communication, and the movers were fantastic. My piano arrived without a scratch!", date: "October 2025" },
    { name: "Lisa Chen", location: "London", rating: 5, text: "Third time using Hitech Transit and they never disappoint. This time was a tricky 4th floor flat with no lift. They managed it efficiently and nothing was damaged.", date: "October 2025" },
    { name: "Michael Hughes", location: "Swansea", rating: 5, text: "Great value for money. Got quotes from several companies and Hitech offered the best price with no hidden costs. The team arrived early and finished ahead of schedule.", date: "September 2025" },
    { name: "Rachel Green", location: "Cardiff", rating: 5, text: "The packing service was worth every penny. They packed my entire 3-bed house in half a day, everything labeled perfectly. Made unpacking so much easier!", date: "September 2025" },
    { name: "Tom Anderson", location: "Reading", rating: 5, text: "Long distance move from Reading to Cardiff. The team were professional, the van was clean and well-maintained, and everything arrived safely. Excellent service.", date: "August 2025" }
  ];

  const avgRating = (reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length).toFixed(1);

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Customer Reviews | Hitech Transit | Rated 4.9/5"
        description={`Read genuine reviews from Hitech Transit customers. Rated ${avgRating}/5 by ${reviews.length} happy movers in Cardiff, South Wales and beyond.`}
        canonical="/reviews"
      />
      <Header />
      
      <main className="pt-20">
        <Breadcrumbs items={[{ label: "Reviews", href: "/reviews" }]} />
        {/* Hero */}
        <section className="bg-[#0F172A] py-20">
          <div className="container-max px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl">
              <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#FF5A1F] mb-4 block">
                Reviews
              </span>
              <h1 className="text-4xl md:text-5xl font-['Outfit'] font-bold text-white tracking-tight mb-6">
                What Our Customers Say
              </h1>
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, i) => (
                    <Star key={`star-${i}`} className="w-6 h-6 fill-[#FF5A1F] text-[#FF5A1F]" />
                  ))}
                </div>
                <span className="text-white text-lg">{avgRating} out of 5 based on {reviews.length} reviews</span>
              </div>
            </div>
          </div>
        </section>

        {/* Reviews Grid */}
        <section className="section-padding">
          <div className="container-max">
            <div className="grid md:grid-cols-2 gap-8">
              {reviews.map((review, index) => (
                <div key={review.title || review.name || `review-${index}`} className="card-surface p-8">
                  <Quote className="w-10 h-10 text-[#FF5A1F]/20 mb-4" />
                  <p className="text-slate-700 leading-relaxed mb-6">
                    "{review.text}"
                  </p>
                  <div className="flex items-center gap-1 mb-3">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={`star-${i}`} className="w-4 h-4 fill-[#FF5A1F] text-[#FF5A1F]" />
                    ))}
                  </div>
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="font-semibold text-[#0F172A]">{review.name}</div>
                      <div className="text-sm text-slate-500 flex items-center gap-1">
                        <MapPin className="w-3 h-3" /> {review.location}
                      </div>
                    </div>
                    <div className="text-sm text-slate-400">{review.date}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="section-padding bg-[#FF5A1F]">
          <div className="container-max text-center">
            <h2 className="text-3xl md:text-4xl font-['Outfit'] font-bold text-white mb-6">
              Ready to Join Our Happy Customers?
            </h2>
            <p className="text-white/90 text-lg max-w-2xl mx-auto mb-8">
              Experience the Hitech Transit difference for yourself.
            </p>
            <Link to="/instant-quote" className="bg-[#0F172A] text-white font-semibold px-8 py-4 inline-flex items-center gap-2 hover:bg-slate-800 transition-colors" data-testid="reviews-cta-btn">
              Get Your Quote
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ReviewsPage;
